var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6863 17.3054H3.82124C1.80418 17.3054 0.261719 15.763 0.261719 13.7459V4.25386C0.261719 2.2368 1.80418 0.694336 3.82124 0.694336H15.6863C17.7034 0.694336 19.2458 2.2368 19.2458 4.25386V13.7459C19.2458 15.763 17.7034 17.3054 15.6863 17.3054ZM27.5514 16.1189H26.3649C26.0089 16.1189 25.7716 16.0003 25.5343 15.763L21.9748 12.2035C21.7375 11.9662 21.6189 11.7289 21.6189 11.3729V6.62688C21.6189 6.27092 21.7375 6.03362 21.9748 5.79632L25.5343 2.2368C25.7716 1.99949 26.0089 1.88084 26.3649 1.88084H27.5514C28.2633 1.88084 28.7379 2.35545 28.7379 3.06735V14.9324C28.7379 15.6443 28.2633 16.1189 27.5514 16.1189Z",
    fill: "#0463EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.b43568b08e989668760277f29f3398ed.svg";
export { ForwardRef as ReactComponent };